module.exports = __webpack_public_path__ + "img/programa-capacitacion.c29e0cc1.png";